export default "__VITE_ASSET__LGtSLX3X__"